(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Via', Via);

    Via.$inject = ['$resource'];

    function Via ($resource) {
        var resourceUrl =  'api/vias/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/vias/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
